import { getContent } from "../../../../../dependencies/getContent/dev";
import { submitPayment } from "../../../../../dependencies/submitPayment/dev";
import { submitPayment as sendSmsCode } from "../../../../../dependencies/submitPayment/dev.resend";
import { getUserAccountInfo } from "../../../../../dependencies/getUserAccountInfo/dev";
import { getMapStateToSMSConfirmationPopupProps } from "./logic/logic";
export var mapStateToSMSConfirmationPopupProps = getMapStateToSMSConfirmationPopupProps({
  getContent: getContent,
  sendSmsCode: sendSmsCode,
  submitPayment: submitPayment,
  getUserAccountInfo: getUserAccountInfo
});